import { render } from "./AppOnboarding.vue?vue&type=template&id=614204ae&scoped=true&lang=pug"
import script from "./AppOnboarding.vue?vue&type=script&setup=true&lang=js"
export * from "./AppOnboarding.vue?vue&type=script&setup=true&lang=js"

import "./AppOnboarding.vue?vue&type=style&index=0&id=614204ae&scoped=true&lang=sass"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-614204ae"]])

export default __exports__